import React from 'react';
import './Footer.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [serverStatus, setServerStatus] = React.useState(null);

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const base = API_BASE.replace(/\/+$/, '');
        const url = `${base}/api/health`;
        const res = await fetch(url);
        if (!mounted) return;
        if (res.ok) {
          const data = await res.json();
          setServerStatus({ ok: data.ok, host: data.smtp?.host, port: data.smtp?.port });
        } else {
          setServerStatus({ ok: false });
        }
      } catch (e) {
        setServerStatus({ ok: false });
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3><i className="fas fa-chart-line"></i> NV Consulting</h3>
            <p>Your trusted partner for all business and financial services. We make compliance easy and affordable.</p>
            <div className="social-links">
              <a href="#facebook" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="#twitter" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#linkedin" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="#instagram" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#youtube" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Popular Services</h4>
            <ul>
              <li><a href="#gst">GST Registration</a></li>
              <li><a href="#company">Company Registration</a></li>
              <li><a href="#itr">Income Tax Filing</a></li>
              <li><a href="#trademark">Trademark Registration</a></li>
              <li><a href="#accounting">Accounting Services</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-list">
              <li><i className="fas fa-phone"></i> +91 7033271030</li>
              <li><i className="fas fa-envelope"></i> support@nvconsulting.in</li>
              <li><i className="fas fa-map-marker-alt"></i> Near Ratanpur Sahayak Thana, Ratanpur Middle School Road, Begusarai, Bihar 851101</li>
              <li><i className="fas fa-clock"></i> Mon - Sat: 9 AM - 7 PM</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} NV Consulting. All rights reserved.</p>
          <div className="footer-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms & Conditions</a>
            <a href="#refund">Refund Policy</a>
            <span className={`server-badge ${serverStatus?.ok ? 'ok' : 'down'}`} title={serverStatus?.ok ? `Email server: ${serverStatus?.host}:${serverStatus?.port}` : 'Email server unreachable'}>
              {serverStatus?.ok ? 'Server: Online' : 'Server: Offline'}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
